import { Button } from 'components/Button';
import { useState } from 'react';
import { Container, Content, CloseButton, ContainerButtons, ContainerTitle } from './styles';

interface IProps {
    showOverlay: () => void;
    deleteCampaign: (id: string) => Promise<void>;
    campaignId: string;
}

export function OverlayDeleteCampaign({ showOverlay, campaignId, deleteCampaign }: IProps): JSX.Element {
    const [isClicked, setIsClicked] = useState(false);

    return (
        <Container>
            <Content>
                <ContainerTitle>
                    <div className="text">
                        <h1>Você está prestes a excluir esta campanha.</h1>
                        <br />
                        <h2>⚠️ ATENÇÃO: Esta ação é irreversível!</h2>
                        <br />
                        <h1>Tem certeza que deseja excluir esta campanha?</h1>
                    </div>
                    <CloseButton fill="#f00" size={30} onClick={() => showOverlay()} />
                </ContainerTitle>

                <ContainerButtons>
                    <Button color="primary" onClick={() => showOverlay()}>
                        Cancelar
                    </Button>
                    <Button
                        color="red"
                        onClick={() => {
                            deleteCampaign(campaignId);
                            setIsClicked(true);
                        }}
                        disabled={isClicked}
                    >
                        Sim, excluir campanha
                    </Button>
                </ContainerButtons>
            </Content>
        </Container>
    );
}
